import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Col,
  CustomInput,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import { ContFilterYear, ContPaginationPage } from '../../../styled-components';
import SearchInput from '../../../commons/SearchInput';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';
import SignalsTable from './SignalsTable';
import generateMonthOptions from '../../../lib/helpers/generateMonthOptions';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';

const SignalsPresentational = ({
  data,
  signalTypes,
  profile,
  newIsAdmin,
  query,
  total,
  onFilter,
  onUpdateSignal,
  searchSignalmens,
  searchAdmins,
  handleFileListView,
  deleteFileConfirm,
}) => {
  const [t] = useTranslation('SIGNALS');
  const { signalTypeCode, limit, offset } = query;

  return (
    <section>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <section>
            <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.signalman }}
                  onFilter={({ search }) => onFilter({ signalman: search })}
                  label={t('SIGNALMAN_SEARCH')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.admin }}
                  onFilter={({ search }) => onFilter({ admin: search })}
                  label={t('ADMIN_SEARCH')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.commercial }}
                  onFilter={({ search }) => onFilter({ commercial: search })}
                  label={t('COMMERCIAL_SEARCH')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.notes }}
                  onFilter={({ search }) => onFilter({ notes: search })}
                  label={t('NOTES_SEARCH')}
                />
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('ACCOUNTABILITY_YEAR_FILTER')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="accountabilityYear"
                          name="accountabilityYear"
                          value={query && query.accountabilityYear}
                          onChange={({
                            target: { value: accountabilityYear },
                          }) => onFilter({ accountabilityYear })}
                        >
                          {generateYearOptions(true)}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('ACCOUNTABILITY_MONTH_FILTER')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="accountabilityMonth"
                          name="accountabilityMonth"
                          value={query && query.accountabilityMonth}
                          onChange={({
                            target: { value: accountabilityMonth },
                          }) => onFilter({ accountabilityMonth })}
                        >
                          {generateMonthOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            </Row>
          </section>

          <section style={{ marginTop: '1rem' }}>
            <SignalsTable
              data={data}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
              onUpdateSignal={onUpdateSignal}
              searchSignalmens={searchSignalmens}
              searchAdmins={searchAdmins}
              signalTypes={signalTypes}
              handleFileListView={handleFileListView}
              deleteFileConfirm={deleteFileConfirm}
            />

            <ContPaginationPage>
              <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

              <FormGroup>
                <CustomInput
                  type="select"
                  className="pagination-select"
                  id="perPage"
                  name="perPage"
                  value={limit}
                  onChange={({ target: { value: limit } }) => {
                    onFilter({ limit: limit });
                  }}
                >
                  {generatePaginationOptions()}
                </CustomInput>
              </FormGroup>
            </ContPaginationPage>
          </section>
        </TabPane>
      </TabContent>
    </section>
  );
};

export default SignalsPresentational;
